import {Component, OnInit} from '@angular/core';
import {Page} from "../../models/page";
import {ActivatedRoute, Router} from "@angular/router";
import {PageService} from "../../services/page.service";
import {HttpCommonService} from "../../services/http-common.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-information-list',
  templateUrl: './information-list.component.html',
  styleUrls: ['./information-list.component.css']
})
export class InformationListComponent implements OnInit {

  fromType = '0';
  url: any;

  page: Page = new Page();
  totals: any = 0;
  newsList: any;

  userId: any;
  userName: any;

  constructor(private router: Router, private routerInfo: ActivatedRoute,
              private httpService: HttpCommonService, private pageService: PageService,
              private titleService:Title) {
    this.userId = this.routerInfo.snapshot.queryParams['userId'];
    this.userName = this.routerInfo.snapshot.queryParams['userName'];
    if (this.routerInfo.snapshot.queryParams['fromType']) {
      this.fromType = this.routerInfo.snapshot.queryParams['fromType'];
    }
    if(this.fromType == "0") {//电商资讯0
      this.titleService.setTitle("电商资讯");
      this.url = "/xhxy_Json/gdswt/gdds/index.json";
    } else if(this.fromType == "1") {//物流资讯1
      this.titleService.setTitle("物流资讯");
      this.url = "/xhxy_Json/gdswt/gdwl/index.json";
    }

  }

  ngOnInit() {
    this.getList();
    this.pageService.pageChange.debounceTime(0).subscribe(page => {
        this.page = page;
        this.getList();
      }
    );
  }

  getList() {
    let last = "index.json";
    if(this.page.pageNo > 1) {
      last = "index_" + this.page.pageNo + ".json";
    }
    this.url = this.url.substring(0,this.url.lastIndexOf("/") + 1) + last;
    this.httpService.get("/user/center/xhsRest/getNewsList",
      {url: this.url}).subscribe(result => {
      if(result.stateCode == "1") {
        this.newsList = result.data.list;
        this.totals = result.data.pageTotal;
        if (this.newsList != null && this.newsList != '') {
          for (let i = 0; i < this.newsList.length; i++){
            if (this.newsList[i].subTitle != null && this.newsList[i].subTitle.length > 120) {
              this.newsList[i].subTitle = this.newsList[i].subTitle.substring(0,115) + "...";
            }
          }
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/information-list/information-list.component.ts